"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgFileWithItemsFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M19.82 7.998H14V2.184c.293.146.625.417.996.813l4.007 4.006c.426.38.699.71.818.995h-.001zM20 9.99V20c0 1.333-.667 2-2 2H6.002C4.667 22 4 21.334 4 20V4c0-1.333.667-2 2-2h6v5.998c0 1.358.667 2.025 2 2 1.196-.023 3.196-.025 6-.007V9.99zM9 15h6c.667 0 1-.333 1-1s-.333-1-1-1H9.001c-.667 0-1 .333-1.001 1 0 .667.333 1 1 1zm0-4h1c.667 0 1-.333 1-1s-.333-1-1-1h-.999c-.667 0-1 .333-1.001 1 0 .667.333 1 1 1zm0 8h6c.667 0 1-.333 1-1s-.333-1-1-1H9c-.667 0-1 .333-1 1s.333 1 1 1z' }))); };
exports.default = SvgFileWithItemsFilled;
//# sourceMappingURL=FileWithItemsFilled.js.map